/**
 * A single-colour SVG painted as a CSS `mask-image`, so the shape takes the
 * element's own `background-color` and can flip on hover or inherit a theme
 * token — the source file's baked `fill` is ignored entirely.
 *
 * ⭐ EXTRACTED ON ITS SECOND USE. The footer's social row had carried these ten
 * inline style properties since 2026-05; the article share row needed the SAME
 * brand marks (owner, 2026-09-09), and pasting the block would have put two
 * copies of a mask setup one edit apart. An `<img>` cannot be recoloured
 * without filter hacks and an inlined `<svg>` component is overkill for a
 * third-party logo, which is why this is a mask and not either of those.
 *
 * ⚠️ `size` IS PER ICON AND IS NOT A NUISANCE PARAMETER. Source logos differ
 * wildly in how much of their own viewBox the glyph fills — Facebook's occupies
 * ~69% of a 32-unit box, Threads' ~92% of a 1082-unit one — so rendering them
 * all at one size makes some read visibly smaller than their neighbours. Tune
 * each until the optical weights match, and measure rather than assume: `mask-
 * size: contain` fits by the LARGER ratio, so a portrait viewBox is bound by
 * its height and a landscape one by its width.
 *
 * ⚠️ Always `aria-hidden`: it is a painted box with no text. The accessible
 * name belongs on the surrounding `<a>` / `<button>`.
 */
export default function MaskIcon({
  src,
  size,
  className,
}: {
  src: string;
  size: number;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={`block ${className ?? ""}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
    />
  );
}
